var path = 'scripts/views/modals/window-template.html';
var html = "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n     uib-modal-animation-class=\"fade\"\n     modal-in-class=\"in\"\n     ng-style=\"{'z-index': 9050 + index*10, display: 'block'}\" ng-click=\"close($event)\">\n    <div class=\"modal-dialog mtl\" ng-class=\"size ? 'modal-' + size : ''\">\n        <div class=\"modal-content\" uib-modal-transclude></div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/modals/window-template.html
// module id = 404
// module chunks = 0